export default "__VITE_ASSET__Bt9HA8RL__"